import React from 'react';

interface AboutSectionEditableProps {
  aboutText: string;
  onAboutTextChange: (text: string) => void;
}

const AboutSectionEditable: React.FC<AboutSectionEditableProps> = ({
  aboutText,
  onAboutTextChange,
}) => {
  return (
    <section className="mb-8 border-b pb-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">About Us</h2>
      <textarea
        className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
        rows={5}
        value={aboutText}
        onChange={(e) => onAboutTextChange(e.target.value)}
      ></textarea>
    </section>
  );
};

export default AboutSectionEditable;